import axiosInstance from "./axiosInstance";

const clearSession = () => {
  ["access_token", "refresh_token", "user", "user_type", "access_type", "login_time"].forEach((key) => localStorage.removeItem(key));
};

const AuthService = {
  login: async (payload) => {
    clearSession();
    const response = await axiosInstance.post("auth/login/", payload);
    const data = response.data;
    localStorage.setItem("access_token", data.access);
    localStorage.setItem("refresh_token", data.refresh);
    localStorage.setItem("user", JSON.stringify(data.user || {}));
    localStorage.setItem("user_type", data.user?.user_type || "");
    localStorage.setItem("access_type", data.user?.access_type || "");
    localStorage.setItem("login_time", new Date().toISOString());
    return data;
  },
  logout: () => clearSession(),
  getCurrentUser: () => {
    try { return JSON.parse(localStorage.getItem("user") || "null"); } catch { return null; }
  },
  isAuthenticated: () => Boolean(localStorage.getItem("access_token")),
  getAccessType: () => localStorage.getItem("access_type"),
};
export default AuthService;
